const getAlignmentIssueHeadingCells = (intl) => [
  {
    children: intl.formatMessage({
      defaultMessage: 'Match',
      id: '6da89',
    }),
    id: 'Match',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Match Id',
      id: 'd7b6f',
    }),
    id: 'Match Id',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Period',
      id: '19016',
    }),
    id: 'Period',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Competition',
      id: '1bded',
    }),
    id: 'Competition',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Country',
      id: '59716',
    }),
    id: 'Country',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Match Date & Time',
      id: 'c8c8b',
    }),
    id: 'Match Date & Time',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Version',
      id: '34b6c',
    }),
    id: 'Version',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Misalignment Issue',
      id: '275d1',
    }),
    id: 'Misalignment Issue',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Misalignment Status',
      id: 'c3066',
    }),
    id: 'Misalignment Status',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Actions',
      id: '06df3',
    }),
    id: 'Actions',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Alignment Last Updated',
      id: '5be90',
    }),
    id: 'Alignment Last Updated',
  },
];

export default getAlignmentIssueHeadingCells;
